import { createFileRoute } from '@tanstack/react-router'

import { GenerateQuoteFailedPage } from '#/modules/quote/back-office/generate-quote/generate-quote-failed-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/subscriptions/generate-failed')({
  beforeLoad: (options) => requirePermissions(options, ['subscription.create']),
  component: GenerateQuoteFailedPage,
})
